import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ManagerLayout from "./ManagerLayout";
import Overzicht from "./Overzicht";
import Bestellingen from "./Bestellingen";
import Bewoners from "./Bewoners";
import Bewonersfiche from "./Bewonersfiche";
import Etiketten from "./Etiketten";
import ComingSoon from "./ComingSoon";
import { MANAGER_ROUTES } from "../../utils/managerRouting";

/**
 * Espace CP manager.
 *
 * Le layout est monté une seule fois et enveloppe toutes les sous-routes, pour
 * que la sidebar ne se remonte pas à chaque navigation.
 */
const Manager = () => (
  <ManagerLayout>
    <Switch>
      <Route exact path={MANAGER_ROUTES.overview} component={Overzicht} />
      <Route exact path={MANAGER_ROUTES.orders} component={Bestellingen} />
      <Route exact path={MANAGER_ROUTES.residents} component={Bewoners} />
      <Route exact path={`${MANAGER_ROUTES.residents}/:residentId`} component={Bewonersfiche} />
      <Route exact path={MANAGER_ROUTES.labels} component={Etiketten} />
      <Route
        exact
        path={MANAGER_ROUTES.monthly}
        render={() => (
          <ComingSoon
            title="Maandoverzicht"
            description="Een maandelijkse samenvatting per bewoner en per afdeling, klaar om door te sturen."
          />
        )}
      />
      <Route
        exact
        path={MANAGER_ROUTES.invoicing}
        render={() => (
          <ComingSoon
            title="Facturatie"
            description="Uw facturen en betaalstatus per maand, met de bijhorende bonnen."
          />
        )}
      />
      <Redirect to={MANAGER_ROUTES.overview} />
    </Switch>
  </ManagerLayout>
);

export default Manager;
